import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: theme.spacing(3),
    padding: theme.spacing(10, 2),
    '&.big': {
      height: '75vh',
    },
  },
  emptyStateWithImage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: theme.spacing(3),
    padding: theme.spacing(0, 2, 10),
    '&.big': {
      height: '75vh',
    },
  },
}))

export default useStyles
